export default __webpack_public_path__ + "static/media/UserGroup.4c3d7761.svg";